import { Instance } from 'mobx-state-tree';
import { VisitUnschedulingFailedDtoModelBase } from './VisitUnschedulingFailedDtoModel.base';

/* The TypeScript type of an instance of VisitUnschedulingFailedDtoModel */
export interface VisitUnschedulingFailedDtoModelType extends Instance<typeof VisitUnschedulingFailedDtoModel.Type> {}

/* A graphql query fragment builders for VisitUnschedulingFailedDtoModel */
export { selectFromVisitUnschedulingFailedDto, visitUnschedulingFailedDtoModelPrimitives, VisitUnschedulingFailedDtoModelSelector } from './VisitUnschedulingFailedDtoModel.base';

/**
 * VisitUnschedulingFailedDtoModel
 */
export const VisitUnschedulingFailedDtoModel = VisitUnschedulingFailedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
